import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Submit a job for processing
 */
export const submitJob = async (jobData) => {
  const response = await api.post('/job/process', jobData);
  return response.data;
};

/**
 * Get progress updates (returns EventSource for SSE)
 */
export const getProgressStream = (jobId) => {
  return new EventSource(`${API_BASE_URL}/job/${jobId}/progress`);
};

/**
 * Get results for a completed job
 */
export const getResults = async (jobId) => {
  const response = await api.get(`/job/${jobId}/results`);
  return response.data;
};

// ============================================
// CV Management API Functions
// ============================================

/**
 * Get the current count of PDF resumes in data/
 */
export const getCvStats = async () => {
  const response = await api.get('/cv/stats');
  return response.data;
};

/**
 * Upload one or more PDF resumes into data/
 * @param {File[]} files
 */
export const uploadCvs = async (files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  const response = await api.post('/cv/upload', formData, {
    // Let the browser set multipart/form-data with the correct boundary;
    // the instance default of application/json would otherwise win.
    headers: { 'Content-Type': undefined },
  });
  return response.data;
};

/**
 * Delete all PDF resumes from data/
 */
export const clearCvs = async () => {
  const response = await api.delete('/cv/clear');
  return response.data;
};

// ============================================
// Email API Functions
// ============================================

/**
 * Get the latest ranking results with email data
 */
export const getLatestRanking = async () => {
  const response = await api.get('/ranking/latest');
  return response.data;
};

/**
 * Verify email credentials are configured and valid
 */
export const verifyEmailCredentials = async () => {
  const response = await api.get('/email/verify');
  return response.data;
};

/**
 * Send emails to selected candidates
 * @param {Object} emailData - Email sending configuration
 * @param {number} emailData.top_n - Number of top candidates to email
 * @param {Array} emailData.manual_recipients - Additional recipients [{email}]
 * @param {string} emailData.subject - Email subject
 * @param {string} emailData.html_content - HTML email content
 */
export const sendEmails = async (emailData) => {
  const response = await api.post('/email/send', emailData);
  return response.data;
};

/**
 * Preview email content
 * @param {string} htmlContent - HTML content to preview
 */
export const previewEmail = async (htmlContent) => {
  const response = await api.post('/email/preview', {
    html_content: htmlContent
  });
  return response.data;
};

export default api;

